import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';

interface CreateInstitutionDto {
    name: string;
    code: string;
    description: string;
    email: string;
}

export const PublicService = {

    createInstitution: async (institutionData: CreateInstitutionDto) => {
        const response = await axios.post(
            ENDPOINTS.PUBLIC.INSTITUTION_CREATE,
            institutionData
        );
        return response.data;
    },

    checkCodeUniqueness: async (code: string): Promise<boolean> => {
        const response = await axios.get(
            ENDPOINTS.PUBLIC.CHECK_CODE_UNIQUENESS,
            {
                params: { code }
            }
        );
        return response.data;
    }
};
